import "./DaCheckEmail.css";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";
import { CredentialMgmtDataService } from "../../services/CredentialMgmtDataService";

const DaCheckEmail = () => {
  const { state, search } = useLocation();
  const [submittedEmail, setSubmittedEmail] = useState(
    state?.email || sessionStorage.getItem("da-submitted-email") || "name@email.com"
  );
  const [error, setError] = useState(null);
  const requestLockedRef = useRef(false);
  const credentialService = CredentialMgmtDataService();
  const incomingQueryParams = new URLSearchParams(search);
  const brandId = incomingQueryParams.get("brand_id");
  const lang = incomingQueryParams.get("lang");
  const clientId = incomingQueryParams.get("client_id");

  useEffect(() => {
    if (state?.email) {
      setSubmittedEmail(state.email);
      sessionStorage.setItem("da-submitted-email", state.email);
    }
  }, [state?.email]);

  const handleRequestNewEmail = async (e) => {
    e.preventDefault();
    if (requestLockedRef.current) return;

    requestLockedRef.current = true;
    try {
      const requestQueryParams = new URLSearchParams();
      if (lang) requestQueryParams.set("lang", lang);
      if (brandId) requestQueryParams.set("brand_id", brandId);
      if (clientId) requestQueryParams.set("client_id", clientId);

      const resource = requestQueryParams.toString()
        ? `/accounts/operations/forgot-password?${requestQueryParams.toString()}`
        : "/accounts/operations/forgot-password";

      const payload = { email: submittedEmail, brand_id: brandId };
      await credentialService.forgotPassword(resource, payload);
      setError(null);
      window.location.reload();
    } catch (error) {
      setError("Failed to send email. Please try again.");
    } finally {
      requestLockedRef.current = false;
    }
  };

  return (
    <DaPageWrapper
      wrapperClass="da-msg-card da-page-wrapper"
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.CHECK_EMAIL.TITLE} />}
      subtitle={
        <>
          {translateStatic(T_KEYS.DA.CHECK_EMAIL.DESCRIPTION.PREFIX)}
          <br />
          {submittedEmail}
        </>
      }
    >
      <Typography variant="caption" color="text.secondary" className="da-msg-footer">
        {translateStatic(T_KEYS.DA.CHECK_EMAIL.FOOTER.PREFIX)}
        <a href="#" className="da-footer-text" onClick={handleRequestNewEmail}>
          {translateStatic(T_KEYS.DA.CHECK_EMAIL.FOOTER.LINK)}
        </a>
      </Typography>
      {error && (
        <Typography variant="caption" color="error" className="da-msg-error" sx={{ mt: 2, display: "block" }}>
          {error}
        </Typography>
      )}
    </DaPageWrapper>
  );
};

export { DaCheckEmail };
